import { render, staticRenderFns } from "./TagsView.vue?vue&type=template&id=5d206e46&scoped=true&"
import script from "./TagsView.vue?vue&type=script&lang=js&"
export * from "./TagsView.vue?vue&type=script&lang=js&"
import style0 from "./TagsView.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./TagsView.vue?vue&type=style&index=1&id=5d206e46&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d206e46",
  null
  
)

component.options.__file = "TagsView.vue"
export default component.exports